import React from 'react';
import styled from '@emotion/styled';
import { rem } from 'polished';
import { css } from '@emotion/react';
import { getTrackingValues } from '../../../core/utils/Utils';
import {
  colors,
  animations,
  text,
  spaces,
} from '../../../core/styles/theme/default';
import { P3 } from '../../Typography';
import { CardProps } from '../Card';
import CardIcons from '../partials/Icons';

const StyledTitle = styled.div`
  ${text.h2};
  font-size: ${rem(28)}; //font-size should be the same on all breakpoints
  margin-bottom: ${rem(spaces.delta)};
`;

const StyledSubtitle = styled.div`
  ${text.p2};
  margin-bottom: ${rem(spaces.gamma)};
`;

const StyledLink = styled.a`
  text-decoration: none;
  color: ${colors.grey900};
`;

const StyledCard = styled.div(
  ({ icons }: any) => css`
    height: 100%;
    border: ${rem(1)} solid ${colors.primary};
    border-radius: ${rem(8)};
    padding: ${icons
      ? `${rem(spaces.zeta)} ${rem(spaces.zeta)} ${rem(spaces.eta)}`
      : `${rem(spaces.eta)} ${rem(spaces.zeta)} ${rem(spaces.eta)}`};
    transition: transform ${animations.slow};
    overflow: hidden;

    &:hover {
      transform: translateY(-${rem(spaces.delta)});
    }
  `,
);

const CardContent = ({ icons, title, subtitle, text }: CardProps) => {
  return (
    <StyledCard icons={icons}>
      {icons && <CardIcons icons={icons} />}
      {title && <StyledTitle>{title}</StyledTitle>}
      {subtitle && <StyledSubtitle>{subtitle}</StyledSubtitle>}
      {text && <P3>{text}</P3>}
    </StyledCard>
  );
};

const DefaultCard = ({ link, tracking, ...rest }: CardProps) => {
  const trackingProps = getTrackingValues({ tracking });

  return link ? (
    <StyledLink {...link} {...trackingProps}>
      <CardContent {...rest} />
    </StyledLink>
  ) : (
    <CardContent {...rest} />
  );
};

export default DefaultCard;
